import { Alert, Stack } from '@mui/material';

import { AccordionWithHeading } from '../../components/general';
import { type AkaVeranstaltungId } from '../../dtos';
import { trpc } from '../../trpc';

type TerminWarningsCardProps = {
  readonly akaVeranstaltungId: AkaVeranstaltungId;
};

export const TerminWarningsCard = (props: TerminWarningsCardProps) => {
  const { akaVeranstaltungId } = props;

  const healthCheckQuery = trpc.veranstaltung.getHealthByVeranstaltung.useQuery({ akaVeranstaltungId });

  return healthCheckQuery.data?.length ? (
    <AccordionWithHeading heading="Warnungen | Fehler">
      <Stack spacing={1}>
        {healthCheckQuery.data.map((result) => (
          <Alert severity={result.type} key={result.message}>
            {result.message}
          </Alert>
        ))}
      </Stack>
    </AccordionWithHeading>
  ) : null;
};
